export class ESPError extends Error {}

export class TimeoutError extends ESPError {}
